import { useSelector } from 'react-redux';

export const useChatsUnreadCount = () => {
  const totalUnread = useSelector((state) => state.messages.totalUnread);

  return totalUnread;
};
